const petCountOptionItems = [
  {
    value: 0,
    label: 'None',
  },
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3+',
  },
];

export default petCountOptionItems;
